// extracted by mini-css-extract-plugin
export var box = "_5z-0";
export var check = "_5z-1";
export var checkboxButton = "_5z-6";
export var checkboxGroup = "_5z-5";
export var disabled = "_5z-7";
export var ghost = "_5z-9";
export var input = "_5z-2";
export var label = "_5z-4";
export var normal = "_5z-8";
export var uncheck = "_5z-3";